<div
  class="icon-wrapper d-flex justify-content-center align-items-center"
  [class.active]="active()"
>
  <lbt-icon size="xlg" [color]="active() ? 'black-0' : 'black-4'">{{ icon() }}</lbt-icon>
</div>
